import { useState, useEffect } from "react";

interface Props {
  getRemainingMs: () => number;
}

export default function Timer({ getRemainingMs }: Props) {
  const [remainingMs, setRemainingMs] = useState(() => getRemainingMs());

  useEffect(() => {
    const tick = () => setRemainingMs(getRemainingMs());
    tick();
    const id = setInterval(tick, 500);
    return () => clearInterval(id);
  }, [getRemainingMs]);

  const seconds = Math.ceil(remainingMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const warning = remainingMs < 10000;

  return (
    <div className={`text-2xl font-mono font-bold ${
      warning ? "text-red-400 animate-pulse" : "text-vsw-200"
    }`}>
      {minutes}:{secs.toString().padStart(2, "0")}
    </div>
  );
}